import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  AggregatedRDataSpecialtyPracticeViewModel,
  GetAggregatedRDataSpecialtyPracticeRequest,
  ListRDataItemSortBy,
  PositionType,
  PracticeType,
  PracticeUserViewModel,
  RDataPracticeViewModel,
  RDataPracticeViewModelPaginatedItemsViewModel,
  Region,
  SortOrder,
} from '../api/models';
import { PracticeUserProfileService } from '../api/services';
import { RDataPracticeService } from '../api/services/r-data-practice.service';
import { RdataRecordsRequest } from '../models/rdata-records-request';

@Injectable({
  providedIn: 'root',
})
export class RDataService {
  constructor(
    private rDataPracticeService: RDataPracticeService,
    private practiceUserProfileService: PracticeUserProfileService
  ) {}

  getRDataAggregatesResponse(request: GetAggregatedRDataSpecialtyPracticeRequest): Observable<HttpResponse<AggregatedRDataSpecialtyPracticeViewModel>> {
    return this.rDataPracticeService
      .compensationApiPracticeRdataAggregatesPost$Json$Response({
        body: {
          specialty: request.specialty,
          region: request.region,
        },
      })
      .pipe(
        catchError((err: HttpErrorResponse) => {
          console.error(err);

          return of({
            body: null,
            ok: err.ok,
            status: err.status,
            statusText: err.statusText,
            url: err.url,
          } as HttpResponse<AggregatedRDataSpecialtyPracticeViewModel>);
        }),
        map((response) => response)
      );
  }

  getRDataRecord(id: string): Observable<RDataPracticeViewModel> {
    return this.rDataPracticeService
      .compensationApiPracticeRdataIdGet$Json$Response({
        id: id,
      })
      .pipe(
        catchError((err: HttpErrorResponse) => {
          console.error(err);
          return of({
            body: null,
            ok: err.ok,
            status: err.status,
            statusText: err.statusText,
            url: err.url,
          } as HttpResponse<RDataPracticeViewModel>);
        }),
        map((response) => response.body)
      );
  }

  getRDataRecordsResponse(request: RdataRecordsRequest): Observable<HttpResponse<RDataPracticeViewModelPaginatedItemsViewModel>> {
    return this.rDataPracticeService
      .compensationApiPracticeRdataListGet$Json$Response({
        Specialties: request.Specialties,
        Academic: request.Academic,
        Verified: request.Verified,
        StateAbbreviations: request.StateAbbreviations,
        PositionType: request.PositionType,
        PracticeTypes: request.PracticeTypes,
        Region: request.Region,
        PageSize: request.PageSize,
        PageNumber: request.PageNumber,
        SortBy: request.SortBy,
        SortOrder: request.SortOrder,
      })
      .pipe(
        catchError((err: HttpErrorResponse) => {
          console.error(err);
          return of({
            body: null,
            ok: err.ok,
            status: err.status,
            statusText: err.statusText,
            url: err.url,
          } as HttpResponse<RDataPracticeViewModelPaginatedItemsViewModel>);
        }),
        map((response) => response)
      );
  }

  getUserDetails(): Observable<PracticeUserViewModel> {
    return this.practiceUserProfileService
      .userProfileApiPracticePracticeGet$Json$Response()
      .pipe(
        catchError((err: HttpErrorResponse) => {
          console.error(err);
          return of({
            body: null,
            ok: err.ok,
            status: err.status,
            statusText: err.statusText,
            url: err.url,
          } as HttpResponse<PracticeUserViewModel>);
        }),
        map((response) => response.body)
      );
  }
}
